import { memo } from "react";
import { useParams } from "react-router-dom";
import { Alert } from "@mui/material";
import PageLayout from "../../../../components/PageLayout";
import { useApp } from "../../hooks/useApp";
import { AppSettings } from "../../components/AppSettings";

export const AppScreen = memo(() => {
  const { id } = useParams<{ id: string }>();
  const [data, loading, error] = useApp(id);

  return (
    <PageLayout
      title={`App | ${data ? data.name : id}`}
      loading={loading}
      empty={error === null && data === null}
      backUrl='/companies?apps'
      onlyUrl
    >
      {error !== null && <Alert severity='error'>{error.toString()}</Alert>}

      {data && (
        <div>
          <AppSettings appId={id!} publicKey={data.publicKey || ""} />
        </div>
      )}
    </PageLayout>
  );
});
